module.exports = __webpack_public_path__ + "static/img/BI.7e09df5c.svg";